<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponenteSolicitudes
        :icono="icono"
        :titulo="titulo"
        :codigoTitulo="codigoTitulo"
        :subTitulo="subTitulo"
        :cifrasControl="cifrasControl"
        :datosTabla.sync="datosTabla"
        :resource="resource"
        :totalRows="totalRows"
        @_funcionExtra="getObtenerDatosBandeja"
        @_funcionExtra2="abrirModalMotivo"
        @_actualizaFecha="actualizarFechaDescentralizada"
    >
    </BandejaComponenteSolicitudes>

    <!--  Modal motivo   -->
    <b-modal
        ref="motivo"
        title="Motivo de rechazo del PTI"
        hide-footer
    >
      <br />
      <h4 v-if="solicitud !== null" class="my-4 text-left">{{ solicitud.motivoRechazo }}</h4>
      <br />
      <b-button
          class="mt-3"
          variant="outline-info"
          block
          @click="cerrarModal()"
      >Cerrar</b-button
      >
      <br /><br/>
    </b-modal>
  </div>
</template>

<script>
import BandejaComponenteSolicitudes from "@/views/bandejaSolicitudesDescentralizados/BandejaComponenteSolicitudes";
import Swal from "sweetalert2";

export default {
  name: "BandejaDescentralizacionRechazados",

  components: {
    BandejaComponenteSolicitudes,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    fechaFin: "",
    fechaIncio: "",
    idPaciente: 0,
    datosTabla: [],
    fieldsPendientes: [
      { key: "nombreTipoSolicitud", label: "Tipo De Solicitud", sortable: true},
      { key: "dtefechaAlta", label: "Fecha", sortable: true, component: "BandejaFechaTextoComponente"},
      { key: "idPaciente", label: "ID", sortable: true},
      { key: "nombrePaciente", label: "Paciente", sortable: true, component: "BandejaLinkPacientePTIPresuntivoComponente",},
      { key: "nombreClinica", label: "Clinica", sortable: true,},
      { key: "nombreDiagnosticador", label: "Diagnosticador", sortable: true, component: "BandejaDiagnosticadorComponente",},
      { key: "nombreSolcitante", label: "OG", sortable: true,},
      { key: "motivoRechazo", label: "Motivo de rechazo del PTI", sortable: true, component: "BandejaMotivoRechazoComponente"},
        {
            key: "intIdNivelPTI",
            label: "Nivel PTI",
            sortable: true
        },
      { key: "cambiarEstatusSinTomadeHdx", label: "Cambiar A Estatus Sin Toma De Hdx", sortable: true, component: "BandejaCambiarEstatusEnEsperaComponente",}
    ],
    fieldsEnProceso: [
      { key: "nombreTipoSolicitud", label: "Tipo De Solicitud", sortable: true },
      { key: "dtefechaAlta", label: "Fecha", sortable: true, component: "BandejaFechaTextoComponente" },
      { key: "idPaciente", label: "ID", sortable: true },
      { key: "nombrePaciente", label: "Paciente", sortable: true, component: "BandejaLinkPacientePTIPresuntivoComponente"},
      { key: "nombreClinica", label: "Clinica", sortable: true },
      { key: "nombreDiagnosticador", label: "Diagnosticador", sortable: true, component: "BandejaDiagnosticadorComponente"},
      { key: "motivoRechazo", label: "Motivo de rechazo del PTI", sortable: true, component: "BandejaMotivoRechazoComponente"},
        {
            key: "intIdNivelPTI",
            label: "Nivel PTI",
            sortable: true
        },
      { key: "nombreSolcitante", label: "OG", sortable: true},
      { key: "regresarPendiente", label: "Regresar Estatus", sortable: true, component: "BandejaRegresarEstatusPendienteComponente"},
      { key: "cambiarEstatusSinTomadeHdx", label: "Cambiar A Estatus Sin Toma De Hdx", sortable: true, component: "BandejaCambiarEstatusEnEsperaComponente"}
    ],
    fieldsFinalizados: [
      { key: "nombreTipoSolicitud", label: "Tipo De Solicitud", sortable: true},
      { key: "dtefechaAlta", label: "Fecha", sortable: true, component: "BandejaFechaTextoComponente"},
      { key: "idPaciente", label: "ID", sortable: true},
      { key: "nombrePaciente", label: "Paciente", sortable: true, component: "BandejaLinkPacientePTIPresuntivoComponente"},
      { key: "nombreClinica", label: "Clinica", sortable: true},
      { key: "nombreDiagnosticador", label: "Diagnosticador", sortable: true, component: "BandejaDiagnosticadorComponente"},
      { key: "nombreSolcitante", label: "OG", sortable: true},
        {
            key: "intIdNivelPTI",
            label: "Nivel PTI",
            sortable: true
        },
      { key: "dtefechaModificacion", label: "Fecha De Salida De Pti", component: "BandejaFechaTextoComponente"},
      { key: "motivoRechazo", label: "Motivo de rechazo del PTI", sortable: true, component: "BandejaMotivoRechazoComponente"}
    ],
    fieldsSinTomaHdx: [
      { key: "nombreTipoSolicitud", label: "Tipo De Solicitud", sortable: true},
      { key: "dtefechaAlta", label: "Fecha", sortable: true, component: "BandejaFechaTextoComponente"},
      { key: "idPaciente", label: "ID", sortable: true},
      { key: "nombrePaciente", label: "Paciente", sortable: true},
      { key: "nombreClinica", label: "Clinica", sortable: true},
      { key: "nombreDiagnosticador", label: "Diagnosticador", sortable: true, component: "BandejaDiagnosticadorComponente"},
      { key: "nombreSolcitante", label: "OG", sortable: true},
        {
            key: "intIdNivelPTI",
            label: "Nivel PTI",
            sortable: true
        },
      { key: "motivoRechazo", label: "Motivo de rechazo del PTI", sortable: true, component: "BandejaMotivoRechazoComponente"},
      { key: "regresarPendiente", label: "Regresar Estatus", sortable: true, component: "BandejaRegresarEstatusPendienteComponente"}
    ],

    cifrasControl: [
      {
        id: 1,
        nombre: "Pendientes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
        permiso: "Bj_descentral_pend",
      },
      {
        id: 2,
        nombre: "En proceso",
        cantidad: 0,
        icono: "star-half",
        layoutTabla: [],
        permiso: "Bj_descentral_proces",
      },
      {
        id: 3,
        nombre: "Finalizados",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
        permiso: "Bj_descentral_fin",
      },
      {
        id: 4,
        nombre: "Sin Toma de Hdx",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
        permiso: "Bj_descentral_Hhdx",
      },
    ],

    icono: "fa fa-credit-card",
    titulo: "Solicitudes",
    codigoTitulo: "Bj_Rech_Des",
    subTitulo: "BANDEJA DE RECHAZOS DESCENTRALIZADOS",
    resource: {
      permiteCambiarDiagnosticador: null,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    },
    idEstatusPestanaSeleccionada : 1,
    pagina: 1,
    totalRows: 0,
    solicitud: null

  }),
  methods:{
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      if(intIdEstuatusSolicitud === undefined)
        intIdEstuatusSolicitud = this.idEstatusPestanaSeleccionada

      let tomaHerramientas = true;
      this.showAlert();
      this.datosTabla = [];
      this.idEstatusPestanaSeleccionada = intIdEstuatusSolicitud;

      if (intIdEstuatusSolicitud === 4){
        tomaHerramientas = false;
      }
      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idPaciente: this.idPaciente,
        intIdEstuatusSolicitud: intIdEstuatusSolicitud,
        tomaHerramientas: tomaHerramientas,
        pagina: this.pagina,
      }

      this.$http
          .post(
              this.$api +
              "ptipresuntivo/obtener/rechazo/deserializado", params )
          .then((response) => {
            //NO devuelve un array asi que no funciona validar isArray
            this.resource.permiteCambiarDiagnosticador =
                response.data.data.blnPermiteEditar;
            this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;
            this.datosTabla = response.data.data.listaResultados;
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          }).finally(() => {
        this.getCifrasPorEstatus();
      });
    },
    getCifrasPorEstatus() {
      this.showAlert();
      this.cifrasControl.forEach(c => c.cantidad = 0)
      this.cifrasControl[0].layoutTabla = this.fieldsPendientes;
      this.cifrasControl[1].layoutTabla = this.fieldsEnProceso;
      this.cifrasControl[2].layoutTabla = this.fieldsFinalizados;
      this.cifrasControl[3].layoutTabla = this.fieldsSinTomaHdx;

      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idPaciente: this.idPaciente,
      }

      this.$http
          .post(
              this.$api +
              "ptipresuntivo/obtener/cifras/rechazo/deserializado", params)
          .then((response) => {
            if (Array.isArray(response.data.data) == true) {
              var data = response.data.data;

              data.forEach((elemento) => {
                if (elemento.idEstatusSolicitud == 1) {
                  this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                }
                if (elemento.idEstatusSolicitud == 2) {
                  this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                }
                if (elemento.idEstatusSolicitud == 3) {
                  this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                }
                if (elemento.idEstatusSolicitud == 4) {
                  this.cifrasControl[3].cantidad = elemento.noTotalSolcitudes;
                }
                if(elemento.idEstatusSolicitud ==  this.idEstatusPestanaSeleccionada){
                  this.totalRows = elemento.noTotalSolcitudes;
                }
              });
            }
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          });
    }, //  ----------------------------

    getObtenerEncargadosClinica() {
      this.showAlert();
      const parametros = {idClinica: this.idClinica}
      this.$http
          .post(
              this.$api +
              "hallazgo/bandeja/obtenerEncargadosClinica", parametros
          )
          .then((response) => {
            //NO devuelve un array asi que no funciona validar isArray

            if (Array.isArray(response.data.data) == true) {
              this.resource.arrayDiagnosticadores = response.data.data;
            }
            Swal.close();
          })
          .catch((error) => {
            console.error(error);
            Swal.close();
          }).finally(() => {
        this.getObtenerDatosBandeja(1);
      });

    },
    actualizarFechaDescentralizada(fechaInicio, fechaFin, idPaciente, pagina) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.pagina = pagina === null? 1: pagina;
      this.getObtenerDatosBandeja(this.idEstatusPestanaSeleccionada);
    },


    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

    abrirModalMotivo(data) {
      this.solicitud = data;
      this.$refs["motivo"].show();
    },

    cerrarModal(){
      this.solicitud = null;
      this.$refs["motivo"].hide();
    }

  },
  mounted() {
    this.getObtenerEncargadosClinica();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    history.forward()
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    var dia1 = new Date();
    dia1.setHours(0, 0, 0, 0);
    dia1.setDate(dia1.getDate() - 1);
    this.fechaInicio = this.$moment(dia1)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },
  computed: {},
};
</script>
